import { useState } from 'react'
import { checkSpecialCharacter } from 'utils/helpers/regex'

const useHandleSpecialCharacter = () => {
  const [formError, setFormError] = useState('')

  const checkValidate = (value, name) => {
    const error = checkSpecialCharacter(value) ? `${name}に誤りがあります` : ''

    setFormError(error)

    if (error) return false

    return true
  }

  const checkMultiValidate = (values = [], names = []) => {
    const error = values
      .map((item, index) => {
        return checkSpecialCharacter(item) ? `${names[index]}に誤りがあります` : null
      })
      .filter(Boolean)
      .join('\n')

    setFormError(error)

    if (error) return false

    return true
  }

  const resetError = () => {
    setFormError('')
  }

  return {
    formError,
    setFormError,
    resetError,
    checkValidate,
    checkMultiValidate,
  }
}

export default useHandleSpecialCharacter
